import { ChevronRight } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgCheveronRight = mkIcon(ChevronRight);